import { useEffect, useRef, useState } from 'react'

export function useCountUp(target: number, threshold = 0.6) {
  const ref = useRef<HTMLDivElement | null>(null)
  const [value, setValue] = useState(0)
  const [done, setDone] = useState(false)

  useEffect(() => {
    const el = ref.current
    if (!el) return
    const observer = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) return
      const step = target / 40
      let current = 0
      const tick = () => {
        current += step
        if (current >= target) {
          setValue(target)
          setDone(true)
        } else {
          setValue(Math.ceil(current))
          requestAnimationFrame(tick)
        }
      }
      tick()
      observer.unobserve(el)
    }, { threshold })
    observer.observe(el)
    return () => observer.disconnect()
  }, [target, threshold])

  return { ref, displayValue: done ? `${target}+` : String(value) }
}
